import axios from 'axios';

export class DashboardService {
    async summaryPerson() {
        return (await axios.get('/persons/dashboard/user-count')).data;
    }
    async summaryBusiness() {
        return (await axios.get('/business/dashboard/business-count')).data;
    }
}